import { useContext } from 'react'
import { DevicesContext } from '~/context/devices'

export default function useDevices() {
  return useContext(DevicesContext)
}
